export enum SUCCESS_ACTION_TYPES {
    SET_IS_SUCCESS = 'success/SET_IS_SUCCESS',
}